/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { withTranslation } from "react-i18next";
import styles from "./Confirmation.module.scss";

const SaveCopy = ({ t, pdfData, confirmationId }) => {
  const createPdf = () => {
    try {
      if (pdfData) {
        var downloadPDFLink = document.createElement("a");
        downloadPDFLink.href = `data:application/pdf;base64,${pdfData.pdfFile}`;
        downloadPDFLink.download = `HARP-Application-${confirmationId}`;
        downloadPDFLink.dispatchEvent(new MouseEvent("click"));
      } else {
        console.log(`Empty pdf data`);
      }
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <React.Fragment>
      <div className={["print_no_display", styles["margin_left_20"]].join(" ")}>
        <button
          onClick={createPdf}
          className={[
            "btn-lg btn-default print_no_display",
            styles["print_save_margin"]
          ].join(" ")}
          value={t("confirmation.save_a_copy")}
          name={t("confirmation.save_a_copy")}
        >
          <i
            className={["fa fa-save", styles["save_icon"]].join(" ")}
            aria-hidden="true"
          ></i>
          {t("confirmation.save_a_copy")}
        </button>
      </div>
    </React.Fragment>
  );
};

export default withTranslation("common")(SaveCopy);
